import { Button } from "@/components/ui/baseUi/button"
import { withForm } from "@/components/ui/forms/hooks/useFormHook"
import { Text } from "@/components/ui/baseUi/text"
import { coachFormDataDefaultValues } from "@/modules/coach/types/coachFormTypes"
import { word } from "@/modules/core/utils/i18n"
import { useUser } from "@/modules/users/hooks/useUser"
import { Plus } from "lucide-react"

export const CoachCreationIdentityStep = withForm({
  defaultValues: coachFormDataDefaultValues,
  render: function CoachCreationIdentityStepInner({ form }) {
    const user = useUser()

    return (
      <div className="flex flex-col gap-6">
        <div className="flex flex-col">
          <Text fontStyle="HM" className="font-bold text-textOnSurface-default">
            {word("coach.onboarding.infos.title")}
          </Text>
          <Text fontStyle="BM" className="font-semibold text-textOnSurface-muted">
            {word("coach.onboarding.infos.subtitle")}
          </Text>
        </div>

        <form.AppField name="profilePhoto">
          {(field) => (
            <field.Field className="gap-3">
              <field.Label fontStyle="LM" className="text-textOnSurface-muted uppercase">
                {word("coach.admin.vitrine.photo.title")}
              </field.Label>
              <field.Content>
                <field.ImagePicker
                  type="logo"
                  renderEmpty={
                    <div className="relative flex items-center justify-center">
                      <div className="flex size-38 items-center justify-center rounded-full bg-interactive-background-primary-faded">
                        <Text fontStyle="HL" className="font-semibold text-white">
                          {user.firstname[0]?.toUpperCase()}
                          {user.lastname[0]?.toUpperCase()}
                        </Text>
                      </div>
                      <Button variant="outline" size="iconMd" className="absolute top-0 right-0">
                        <Plus className="size-5 text-textOnSurface-subtle" />
                      </Button>
                    </div>
                  }
                />
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <form.AppField name="commercialName">
          {(field) => (
            <field.Field>
              <field.Label fontStyle="LM" className="gap-1 text-textOnSurface-muted uppercase">
                {word("coach.admin.vitrine.header.commercial_name")}
                <field.Label fontStyle="LM" className="text-feedback-negative-intense">
                  *
                </field.Label>
              </field.Label>
              <field.Content>
                <field.Input />
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <form.AppField name="email">
            {(field) => (
              <field.Field>
                <field.Label fontStyle="LM" className="gap-1 text-textOnSurface-muted uppercase">
                  {word("coach.admin.vitrine.contact.email")}
                  <field.Label fontStyle="LM" className="text-feedback-negative-intense">
                    *
                  </field.Label>
                </field.Label>
                <field.Content>
                  <field.Input type="email" />
                  <Text fontStyle="LS" className="text-textOnSurface-muted">
                    {word("coach.onboarding.infos.email.hint")}
                  </Text>
                  <field.Message />
                </field.Content>
              </field.Field>
            )}
          </form.AppField>

          <form.AppField name="phoneNumber">
            {(field) => (
              <field.Field>
                <field.Content>
                  <field.PhoneInput
                    label={word("coach.admin.vitrine.private.phone")}
                    labelClassName="text-textOnSurface-muted"
                  />
                  <Text fontStyle="LS" className="text-textOnSurface-muted">
                    {word("coach.onboarding.infos.phone.hint")}
                  </Text>
                  <field.Message />
                </field.Content>
              </field.Field>
            )}
          </form.AppField>
        </div>
      </div>
    )
  },
})
